import { Crown, X, Check } from "lucide-react";

const MESSAGES = {
  quota: {
    title: "Has agotado tus análisis gratuitos",
    text: "Usaste tus 3 análisis gratuitos de por vida. Actualiza al Plan Pro para seguir analizando sin límites.",
  },
  compare: {
    title: "La comparación de videos es una función Pro",
    text: "Compara dos videos lado a lado y descubre cuál funciona mejor con el Plan Pro.",
  },
};

const PRO_BENEFITS = [
  "Análisis ilimitados",
  "Comparación de videos lado a lado",
  "Análisis de comentarios con IA",
  "Exportación a PDF y enlaces compartibles",
];

export default function UpgradeModal({ reason = "quota", onClose }) {
  const msg = MESSAGES[reason] || MESSAGES.quota;
  return (
    <div data-testid="upgrade-modal" className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 animate-fadeIn">
        <button
          data-testid="upgrade-modal-close"
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center mb-6 shadow-lg">
          <Crown className="w-8 h-8 text-white" />
        </div>

        <h3 className="text-2xl font-bold text-gray-900 mb-2">{msg.title}</h3>
        <p className="text-gray-600 mb-6">{msg.text}</p>

        <div className="bg-purple-50 rounded-2xl p-5 mb-6 border border-purple-100">
          <p className="text-sm font-bold text-purple-700 uppercase mb-3">Plan Pro incluye</p>
          <ul className="space-y-2">
            {PRO_BENEFITS.map((b, i) => (
              <li key={i} className="flex items-center gap-2 text-sm text-gray-700">
                <Check className="w-4 h-4 text-green-500 flex-shrink-0" />
                {b}
              </li>
            ))}
          </ul>
        </div>

        <a
          href="/precios"
          data-testid="upgrade-modal-pricing-link"
          className="block w-full text-center bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3.5 rounded-xl font-semibold hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl transition-all"
        >
          Ver Planes y Precios
        </a>
        <button
          onClick={onClose}
          className="mt-3 w-full text-center text-sm text-gray-500 hover:text-gray-700 transition-colors"
        >
          Quizás más tarde
        </button>
      </div>
    </div>
  );
}
